export default {
    state: {
        currentError: "",
        currentTitle: ""
    },
    showMessage(message: string, title: string) {
        this.state.currentError = message;
        this.state.currentTitle = title
    },
    showError(message: string) {
        this.state.currentError = message;
        this.state.currentTitle = 'Fehler'
    },
    clearError() {
        this.state.currentError = ""
    }
}

